import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { CreateModal } from "../../../shared/components/Modal";
import useMovimento from "../hooks/useMovimento";
import usePutMovimento from "../hooks/usePutMovimento";
import { MovimentoForm } from "../types";
import { FormMovimentos } from "./Form/FormMovimentos";

interface EditMovimentoModalProps {
  onCancel: () => void;
  deleteModal: () => void;
  visible: boolean;
  MovimentoId: number;
}

export function EditMovimentoModal({
  onCancel,
  visible,
  deleteModal,
  MovimentoId: id,
}: EditMovimentoModalProps) {
  const { register, handleSubmit, reset, setValue, control } = useForm<MovimentoForm>();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [movimento, setMovimento] = useState<MovimentoForm>();
  const { data: movimentoData, isLoading } = useMovimento(id);

  const { mutate: salvarEdicaoMovimento, isLoading: LoadingButton } = usePutMovimento(() => handleCloseLaterSave());

  useEffect(() => {
    movimentoData && setMovimento(movimentoData);
  }, [movimentoData]);

  useEffect(() => {
    reset({
      ...movimentoData,
      DataMovimento: moment(movimentoData?.DataMovimento).utc(false).format("YYYY-MM-DD"),
      DescontoPorcentagem: movimentoData?.DescontoPorcentagem
      ? movimentoData?.DescontoPorcentagem * 100
      : 0,
    });
  }, [movimentoData, reset]);

  async function onSubmit(data: MovimentoForm) {
    const formattedData = {
      ...movimentoData,
      DescontoPorcentagem: movimentoData.DescontoPorcentagem ? movimentoData.DescontoPorcentagem / 100 : 0,
    }
    
    navigator.onLine &&
      await salvarEdicaoMovimento({
        movimentoAtual: movimento ? movimento : formattedData,
        id,
        data: {...data, DescontoPorcentagem: data.DescontoPorcentagem ? data.DescontoPorcentagem / 100 : 0,},
      });
    
      if(!navigator.onLine) {
        Swal.fire({
          title: 'Sem conexão',
          text: 'Por favor, verifique a sua conexão com a internet e tente novamente.',
          icon: 'error',
          position: 'center',
          confirmButtonText: 'OK',
          confirmButtonColor: '#f27474'
        })
      }
  }

  function handleCloseLaterSave() {
    reset();
    onCancel();
    setDisabled(!disabled);
  }
  
  return (
    <>
      <CreateModal
        title="Visualizar Movimento"
        isModalOpen={visible}
        disabled={disabled}
        onCancel={onCancel}
        isLoading={LoadingButton}
        onSubmit={handleSubmit(onSubmit)}
        deleteOpenModal={() => {
          deleteModal();
        }}
        setDisabled={() => setDisabled(!disabled)}
        closable
        hasId
      >
        <FormMovimentos
          register={register}
          control={control}
          setValue={setValue} 
          disabled={disabled}
          movimentos={movimento}
          loading={isLoading}
          formEdit
        />
      </CreateModal>
    </>
  );
}
